import { openExternalLink } from './navigation';

export const toggleInAppHelp = () => {
  openExternalLink('https://help.qatalog.com/');
};
